<template>
  <div class="el-table-container templateBox">
    <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
             @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="80px">
      <el-form-item label="关键字：" prop="keyword">
        <el-input v-model.trim="searchForm.keyword" style="width: 250px" maxlength="20"
                  placeholder="请输入关键字(限20字)"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
        <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
      <el-form-item class="f_r">
        <el-button v-if="hasPermission('academic:academic:learningModel:add')" type="primary"
                   @click="addData(0)"
                   size="small">新增
        </el-button>
        <el-button v-if="hasPermission('academic:academic:learningModel:open')" type="primary"
                   @click="batching(1)"
                   size="small">批量公开
        </el-button>
        <el-button v-if="hasPermission('academic:academic:learningModel:hide')" type="primary"
                   @click="batching(0)"
                   size="small">批量隐藏
        </el-button>
        <el-button v-if="hasPermission('academic:academic:learningModel:deleteColumn')" type="primary"
                   @click="deleteWeb()" size="small">删除
        </el-button>
      </el-form-item>
    </el-form>
    <div class="dataBox">
      <el-table
          :data="dataList"
          v-loading="loading"
          size="small" height="100%"
          class="table" border
          ref="multipleTable"
          :row-key="'id'"
          @selection-change="selectionChangeHandle"
          @sort-change="sortChangeHandle"
      >
        <el-table-column :reserve-selection="true" type="selection" width="50"/>
        <el-table-column prop="modelName" label="模型名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="modelState" label="状态" sortable="custom" show-overflow-tooltip>
          <template slot-scope="{row}">
            <el-switch
                v-model="row.modelState"
                active-value="1"
                @change="setType(row)"
                inactive-value="0">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="modelRemark" label="备注" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateDate" label="最新修改时间" sortable="custom"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="createDate" label="创建时间" sortable="custom"
                         show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" min-width="100px" label="操作">
          <template slot-scope="{row}">
            <el-button v-if="hasPermission('academic:academic:learningModel:detail')" type="text"
                       size="small"
                       @click="addData(1,row)">详情
            </el-button>
            <el-button v-if="hasPermission('academic:academic:learningModel:edit')" type="text" size="small"
                       @click="addData(2,row)">编辑
            </el-button>
            <el-button v-if="hasPermission('academic:academic:learningModel:nodeMg')" type="text"
                       size="small"
                       @click="nodeManager(row)">节点管理
            </el-button>
            <el-button v-if="hasPermission('academic:academic:learningModel:share')" type="text"
                       size="small"
                       @click="shared(row)">分享
            </el-button>
            <el-button v-if="hasPermission('academic:academic:learningModel:deleteColumn')" type="text"
                       size="small" @click="deleteWeb(row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                @pagination="refreshList"/>
    <learning-add ref="learningAdd" @refresh="refreshList"></learning-add>
    <learning-detail ref="learningDetail"></learning-detail>
    <learning-node ref="learningNode" @refresh="refreshList"></learning-node>
    <share-know ref="shareKnow"></share-know>
  </div>
</template>

<script>

import LearningAdd from "@/views/modules/academic/academic/learningAdd.vue";
import LearningDetail from "@/views/modules/academic/academic/learningDetail.vue";
import LearningNode from "@/views/modules/academic/academic/learningNode/learningNode.vue";
import ShareKnow from "@/views/modules/academic/academic/learningNode/shareKnow.vue";

export default {
  name: "learningModel",
  components: {ShareKnow, LearningNode, LearningDetail, LearningAdd},
  data() {
    return {
      searchForm: {
        keyword: '',
        orderBy: "",
        current: 1,
        size: 20,
      },
      total: 0,
      loading: false,
      dataList: [],
      dataListSelect: [],
    }
  },

  mounted() {
      this.refreshList()
  },

  computed: {
    pageType() {
      return this.$route.query.type
    }
  },

  watch:{
    pageType(val){
      if (val) {
        this.refreshList()
      }
    },
  },

  methods: {
    // 获取数据列表 current查第几页数据
    refreshList(type, clearSelect) {
      if (type == 1) {
        this.searchForm.current = 1
      }
      if (clearSelect) {
        this.$refs.multipleTable.clearSelection()
      }
      this.loading = true
      this.$axios(this.api.academic.knowledgemodelList, this.searchForm).then(data => {
        if (data && data.status) {
          this.dataList = data.data.records
          if (this.dataList.length == 0 && this.searchForm.current > 1) {
            this.searchForm.current--
            this.refreshList()
          }
          this.total = parseInt(data.data.total)
          this.loading = false
        } else {
          this.$message.error('查询失败')
        }
      })
    },
    //排序
    sortChangeHandle(obj) {
      obj.prop = this.getHumpLineName(obj.prop);
      if (obj.order === 'ascending') {
        this.searchForm.orderBy = obj.prop + ' asc'
      } else if (obj.order === 'descending') {
        this.searchForm.orderBy = obj.prop + ' desc'
      } else {
        this.searchForm.orderBy = ''
      }
      this.refreshList(1)
    },
    // 重置
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.orderBy = ''
      this.refreshList(1, 1)
    },

    //表格勾选数据
    selectionChangeHandle(val) {
      this.dataListSelect = val
    },

    //切换状态
    setType(row) {
      row.modelState = row.modelState == '1' ? '0' : '1'
      let contData = '隐藏后该知识模型将从公共知识模型库中删除，仅自己可见，是否继续？'
      if (row.modelState == '0') {
        contData = '公开后该知识模型将同步至公共知识模型库，其他用户可查看和保存为自己的知识模型。是否继续？'
      }
      this.$confirm(contData, `确认${row.modelState == '0' ? '公开' : '隐藏'}所选数据 ？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.knowledgemodelUpdateById, {
          id: row.id,
          modelState: row.modelState == '1' ? '0' : '1',
        }, 'put').then(data => {
          if (data && data.status) {
            this.$message.success('状态修改成功')
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    //批量处理 1公开 0隐藏
    batching(num) {
      if (this.dataListSelect.length == 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      let ids = this.dataListSelect.map(item => {
        return item.id
      })
      let contData = '隐藏后该知识模型将从公共知识模型库中删除，仅自己可见，是否继续？'
      if (num == 1) {
        contData = '公开后该知识模型将同步至公共知识模型库，其他用户可查看和保存为自己的知识模型。是否继续？'
      }
      this.$confirm(contData, `确认${num == 1 ? '公开' : '隐藏'}所选数据 ？`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.knowledgemodelUpdateBatchIds, {
          ids,
          modelState: num,
        }, 'put').then(data => {
          if (data && data.status) {
            this.$message.success(`状态修改成功`)
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },

    //num 0新增 1详情 2编辑
    addData(num, row) {
      if (num == 1) {
        this.$refs.learningDetail.init(row)
      } else {
        this.$refs.learningAdd.init(num, row)
      }
    },

    //节点管理
    nodeManager(row) {
      this.$refs.learningNode.init(row)
    },

    //分享
    shared(row) {
      this.$refs.shareKnow.init(row)
    },

    //删除
    deleteWeb(row) {
      let list = row ? [row] : this.dataListSelect
      if (list.length == 0) {
        this.$message.warning('请至少选择一条数据')
        return
      }
      let statusTrueList = []
      let ids = list.map(item => {
        if (item.modelState == 1) {
          statusTrueList.push(item)
        }
        return item.id
      })
      if (statusTrueList.length != 0) {
        this.$message.warning('请先禁用后再删除！')
        return
      }
      this.$confirm(`您是否确认删除数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios(this.api.academic.knowledgemodelRemoveById, {ids}, 'delete').then(data => {
          if (data && data.status) {
            this.$message.success('删除成功')
            this.refreshList('', 1)
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
  }
}
</script>

<style scoped>

</style>
